<template>
  <div class="web">
    <div class="pc-box">
      <!--搜索-->
      <div class="pc-search">
        <div class="pc-search-auto">
          <h2 style="align-items: center;">
            师生互选
            <van-button style="margin-left: 5px" size="small" @click="$router.push('/my/information')">资料修改</van-button>
          </h2>
          <van-search
                  v-model="queryParams.name"
                  show-action
                  placeholder="请输入搜索关键词"
                  @search="onSearch"
                  :clearable="false"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </div>
      </div>
      <!-- 列表数据 -->
      <div class="pc-list">
        <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
        <van-list
                v-model="data.bottomLoading"
                :finished="!data.hasMore"
                finished-text="没有更多了"
                @load="onLoad"
        >
          <div class="tech-list" v-for="item in data.records" :key="item.id">
            <div class="tech-top" @click="toDetail(item)">
              <div class="top-r">
                <h2>{{ item.name }}</h2>
                <div class="time"><img src="@/assets/time.png">活动时间：{{moment(item.startTime).format('YYYY/MM/DD HH:mm') + '-' + moment(item.endTime).format('YYYY/MM/DD HH:mm')}}</div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {queryList} from '@/api/activity/activity'
  import {handlePageData} from '@/utils/common'
  import {getUserInfo} from "@/api/my/my";
  import moment from 'moment'
  export default {
    name: 'Activity',
    components: {},
    data() {
      return {
        moment,
        userInfo: {},
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        queryParams: {},
        data: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
      }
    },
    computed: {},
    created() {
      getUserInfo().then(res => {
        if (res.code === 10000) {
          this.userInfo = res.result
        }
      })
      this.refresh()
    },
    mounted() {
    },
    methods: {
      // 加载数据
      onLoad() {
        if (this.data.current > 1 && this.data.hasMore) {
          this.getDataList()
        }
      },
      // 刷新列表
      refresh() {
        this.reset();
        this.getDataList();
      },
      reset() {
        this.data.current = 1;
        this.data.total = 0;
        this.data.hasMore = true
      },
      // 获取列表数据
      getDataList() {
        if (this.data.loading) return;
        this.data.loading = true;
        this.queryParams.current = this.data.current;
        this.queryParams.size = this.data.size;
        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.data, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.data.loading = false;
            this.data.topLoading = false;
            this.data.bottomLoading = false
          }, 100)
        })
      },
      // tab切换回调方法
      tabChange() {
        this.$nextTick(() => {
          this.data.records = [];
          this.refresh()
        })
      },
      onSearch() {
        this.refresh()
      },
      toDetail(item) {
        if (['student', 'freshman'].includes(this.userInfo.mclassCode)) {
          this.$router.push({path: `/activity/teacherList?id=${item.id}`})
        } else {
          this.$router.push({path: `/activity/studentList?id=${item.id}`})
        }
      }
    }
  }
</script>

<style scoped>
.pc-search h2{
  display:none;
}
  .van-cell__value {
    text-align: left;
  }

  .van-card__thumb {
    width: 30%;
  }

  .van-card__footer {
    margin-top: 20px;
    text-align: center;
  }

  .tech-list {
    /*height: 156px;*/
    background: #FFFFFF;
    border-radius: 6px;
    margin: 10px 0;
    position: relative;
    overflow: hidden;
  }

  .tech-top {
    display: flex;
    padding:15px 10px;
    /*height: 105px;*/
    /*border-bottom: 1px solid #dedede;*/
  }

  /deep/ .van-image {
    display: flex;
    width: 76px;
    height: 88px;
    margin-right: 10px;
  }

  .top-r {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .top-r h2 {
    display: flex;
    align-items: center;
    font-size:18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 21px;
    margin-bottom:15px;
  }

  .tech-info {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .tech-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 51px;
  }

  /deep/ .van-button--info {
    width: 116px;
    height: 32px;
    background: #2C68E4;
    border-radius: 3px;
  }

  .xz {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
  }

  .tech-bottom a {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2C68E4;
  }
  .time{
    font-size: 14px;
    display: flex;
    align-items:center;
    color: #999999;
  }
  .time img{
    width:14px;
    margin-right: 3px;
  }
  @media screen and (min-width:1024px){
    .pc-search{
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff;
    }
    .pc-search h2{
      display: flex;
      padding: 0 20px;
      font-size:18px;
      font-weight: 600;
     }
    .pc-search-auto{
      width: 1024px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .pc-box{
      margin: 0 auto;
    }
    .pc-list{
      width: 1024px;
      margin: 0 auto;
    }
  }
</style>
